import {UPDATE_CACHED_IMG} from './constants';

const initialState = {
  cachedGalleryImg: '',
};

export const reducer = (state = initialState, action) => {
  switch (action.type) {
    case UPDATE_CACHED_IMG:
      return {...state, ...action.payload};
    default:
      return state;
  }
};
